import { Link } from 'react-router-dom';
import { comics, rankingComics } from '@/mocks/comics';

export default function RankingSection() {
  const rankingList = rankingComics
    .map((id) => comics.find((c) => c.id === id)!)
    .filter(Boolean);

  return (
    <section className="py-10 px-4 md:px-6 max-w-[1280px] mx-auto" aria-label="热门排行">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <h2 className="text-xl font-heading text-foreground-900 whitespace-nowrap">
            <strong>热门排行</strong>
          </h2>
          <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap">
            人气榜
          </span>
        </div>
        <Link
          to="/category/all?sort=ranking"
          className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          完整榜单 <i className="ri-arrow-right-line ml-1"></i>
        </Link>
      </div>

      <div className="bg-background-50 rounded-xl border border-background-200/70">
        {rankingList.map((comic, index) => (
          <Link
            key={comic.id}
            to={`/article/${comic.id}`}
            className={`flex items-center gap-4 p-4 transition-colors duration-200 hover:bg-background-100 ${
              index < rankingList.length - 1 ? 'border-b border-background-200/60' : ''
            }`}
          >
            <div className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold whitespace-nowrap ${
              index === 0
                ? 'bg-amber-400 text-white'
                : index === 1
                  ? 'bg-secondary-400 text-white'
                  : index === 2
                    ? 'bg-amber-700 text-white'
                    : 'bg-background-200 text-foreground-500'
            }`}>
              {index + 1}
            </div>

            <div className="flex-shrink-0 w-12 h-16 rounded-md overflow-hidden bg-background-200">
              <img
                src={comic.cover}
                alt={comic.title}
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>

            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-medium text-foreground-900 truncate whitespace-nowrap">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">
                {comic.author}
              </p>
              <div className="flex items-center gap-3 mt-1">
                <span className="flex items-center text-xs text-amber-500">
                  <i className="ri-star-fill text-[10px] mr-0.5"></i>
                  {comic.rating}
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">
                  {comic.views} 阅读
                </span>
              </div>
            </div>

            <div className="flex-shrink-0 flex items-center gap-2">
              <span className={`text-xs px-2 py-0.5 rounded-full whitespace-nowrap ${
                comic.status === '连载中'
                  ? 'bg-accent-100 text-accent-700'
                  : 'bg-secondary-100 text-secondary-700'
              }`}>
                {comic.status}
              </span>
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}